import { createContext, Dispatch } from 'react';
import { AvatarSettings } from '../../core/types';

const StoreCameraSlotContext = createContext<Dispatch<Partial<AvatarSettings>>>(
  () => {},
);

export default StoreCameraSlotContext;
